import type { TriggerSampleOverrides } from "../../sampleGenerators";

export const emailReceivedOverrides: TriggerSampleOverrides = {
  skipKey: key => key === "html" || key === "headers",
};
